import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import type { IProduct } from 'src/types';

@Component({
  selector: 'app-delete-produck-dialog',
  templateUrl: './delete-product-dialog.component.html',
  styleUrls: ['./delete-product-dialog.component.scss'],
})
export class DeleteProductDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { product: IProduct }) {}
}
